export default {
  openApp: {
    title: 'Open the Varo app ',
    body: 'Almost there! Open the Varo app to finish linking your account.',
  },
  errors: {
    addAccountFailed: 'Unable to add Plaid account. Please try again.',
    addAccountUnavailable: 'Unable to add Plaid account',
    updateAccountFailed: 'Unable to update Plaid account. Please try again.',
    updateAccountUnavailable: 'Unable to update Plaid account',
    missingAccountId: 'Account ID is required for this Plaid flow',
    operationCancelled: 'Operation was cancelled',
    unexpectedError: 'An unexpected error occurred',
    maxAttemptsMessage:
      'The number of allowed attempts has been exceeded. Please try again later.',
    maxAttemptsTitle: 'Something went wrong.',
  },
};
